import { render } from "./reportCstmSaleInfo.vue?vue&type=template&id=ed0c084a"
import script from "./reportCstmSaleInfo.vue?vue&type=script&lang=js"
export * from "./reportCstmSaleInfo.vue?vue&type=script&lang=js"

import "./reportCstmSaleInfo.vue?vue&type=style&index=0&id=ed0c084a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__